module.exports = __webpack_public_path__ + "circle-up.afc5a70f61e193b2732aa6ef23e3604f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle-up.svg
// module id = 1130
// module chunks = 0